<!--
  - Copyright (c) 2024. Haodong JU
  -->

<template>
  <div>
    <template v-if="currentBrand">
      <div>
        <v-tabs
          v-model="tab"
          background-color="transparent"
          color="black"
          style="background: transparent"
        >
          <v-tab>品牌设置</v-tab>
          <v-tab>组织架构</v-tab>
          <v-tab>品牌营销</v-tab>
          <v-tab>数据和管理</v-tab>
          <v-tab>区域设置</v-tab>
        </v-tabs>
        <v-divider />
        <v-tabs-items
          v-model="tab"
          style="background: transparent"
        >
          <v-tab-item>
            <branding-setting />
          </v-tab-item>
          <v-tab-item>
            <branding-manage />
          </v-tab-item>
          <v-tab-item>
            <branding-marketing />
          </v-tab-item>
          <v-tab-item>
            <data-management />
          </v-tab-item>
          <v-tab-item>
            <branding-area-setting />
          </v-tab-item>
        </v-tabs-items>
      </div>
    </template>
    <template v-else>
      <div
        class="d-flex flex-column justify-center align-center"
        style="height: 60vh"
      >
        <div class="text-h3 font-weight-bold">
          暂未查询到品牌
        </div>
        <div class="text-subtitle-1 mt-2">
          请点击下方按钮,设置相关品牌
        </div>
        <v-btn
          class="amber lighten-4 black--text mt-4"
          outlined
          @click="addNewBrand"
        >
          新增品牌
        </v-btn>
      </div>
    </template>
    <v-dialog
      v-model="newBrandDialog"
      max-width="400px"
    >
      <v-card class="pa-4">
        <div class="d-flex align-center justify-center">
          <div class="text-h4 font-weight-bold">
            新建品牌
          </div>
          <v-spacer />
          <div>
            <v-btn
              icon
              @click="activeDialog = false"
            >
              <v-icon large>
                mdi-close
              </v-icon>
            </v-btn>
          </div>
        </div>
        <div class="d-flex align-center justify-center mt-8">
          <v-card
            color="#c0c0c0"
            elevation="0"
            height="150px"
            style="position: relative"
            width="150px"
          >
            <div
              style="position:absolute;
                top: 0px;left: 0px;right: 0px;bottom:0px;
                margin:auto;border-radius: 12px"
            >
              <v-img
                :src="userPic"
                style="border-radius: 12px"
              />
            </div>
            <v-file-input
              accept="image/*"
              class="mt-2"
              counter
              dense
              height="150px"
              outlined
              style="opacity: 0;cursor: pointer"
              width="150px"
              @change="processFile"
            />
          </v-card>
        </div>
        <div
          class="d-flex align-center justify-center mt-8"
        >
          <div
            class="text-h5 font-weight-bold px-4"
            style="width: 150px"
          >
            品牌名称:
          </div>
          <v-text-field
            v-model="brandingName"
            class="px-4"
            dense
            hide-details
            outlined
          />
        </div>
        <div class="d-flex align-center justify-center mt-8">
          <v-btn
            class="amber lighten-4 text--black"
            outlined
            width="100%"
          >
            保存
          </v-btn>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>

import BrandingSetting from '@/views/AadenPages/branding/fragments/BrandingSetting.vue'
import BrandingManage from '@/views/AadenPages/branding/fragments/BrandingManage/BrandingManage.vue'
import BrandingMarketing from '@/views/AadenPages/branding/fragments/BrandingMarketing.vue'
import DataManagement from '@/views/AadenPages/branding/fragments/DataManagement.vue'
import BrandingAreaSetting from '@/views/AadenPages/branding/fragments/BrandingAreaSetting.vue'

export default {
  components: {
    BrandingAreaSetting,
    DataManagement,
    BrandingMarketing,
    BrandingManage,
    BrandingSetting
  },
  data () {
    return {
      brandingName: '',
      userPic: null,
      newBrandDialog: false,
      currentBrand: '杨国福',
      items: ['杨国福', '张亮'],
      tab: null
    }
  },
  async mounted () {
  },
  methods: {
    addNewBrand () {
      this.newBrandDialog = true
    },
    async processFile (event) {
      this.userPic = URL.createObjectURL(event)
    }
  }
}
</script>

<style scoped>
.text-slate-500 {
  --tw-text-opacity: 1;
  color: rgb(100 116 139 / var(--tw-text-opacity));
}

.text-slate-600 {
  --tw-text-opacity: 1;
  color: rgb(71 85 105 / var(--tw-text-opacity));
}
</style>
